import {dataHooks} from '@wix/data-hooks'

export const timeSlotsListDataHooks = dataHooks<{
  root: {}
}>('time-slots-list')
